export enum Role {
    APP_ADMIN = 'APP_ADMIN',
    ORG_ADMIN = 'ORG_ADMIN',
    ORG_USER = 'ORG_USER',
    ORG_VIEWER = 'ORG_VIEWER',
}
